<template>
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g opacity="0.2">
      <path d="M28.8933 19.0667L28.36 25.7334C28.16 27.7734 28 29.3334 24.3866 29.3334H7.61331C3.99997 29.3334 3.83997 27.7734 3.63997 25.7334L3.10664 19.0667C2.99997 17.96 3.34664 16.9334 3.97331 16.1467C3.98664 16.1334 3.98664 16.1334 3.99997 16.12C4.73331 15.2267 5.83997 14.6667 7.07997 14.6667H24.92C26.16 14.6667 27.2533 15.2267 27.9733 16.0934C27.9866 16.1067 28 16.12 28 16.1334C28.6533 16.92 29.0133 17.9467 28.8933 19.0667Z" :stroke="color" stroke-width="1.5" stroke-miterlimit="10"/>
      <path d="M4.66663 15.2401V8.37339C4.66663 3.84006 5.79996 2.70673 10.3333 2.70673H12.0266C13.72 2.70673 14.1066 3.21339 14.7466 4.06673L16.44 6.33339C16.8666 6.89339 17.12 7.24006 18.2533 7.24006H21.6533C26.1866 7.24006 27.32 8.37339 27.32 12.9067V15.2934" :stroke="color" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M12.5734 22.6667H19.4267" :stroke="color" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '#71717A'
    },
  },
};
</script>
